module.exports = __webpack_public_path__ + "img/gonetwork2_5.eac2b5b9.png";